import { render } from "./VerifiedUser.vue?vue&type=template&id=3353c0f8&scoped=true&ts=true"
import script from "./VerifiedUser.vue?vue&type=script&lang=ts"
export * from "./VerifiedUser.vue?vue&type=script&lang=ts"

import "./VerifiedUser.vue?vue&type=style&index=0&id=3353c0f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3353c0f8"]])

export default __exports__